class SliderAlsoAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperContainer = this.querySelector('swiper-container');

    if (!this.swiperContainer) {
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    const swiperParams = {
      slidesPerView: this.swiperContainer.getAttribute('slides-per-view') || 1,
      slidesOffsetBefore:  24,
      slidesOffsetAfter: 24,
      breakpoints: {
        767: {
          slidesOffsetBefore:  0,
          slidesOffsetAfter: 0,
        },
      },
    }

    Object.assign(this.swiperContainer, swiperParams);
    this.swiperContainer.initialize();
  }
}

if (!customElements.get('slider-also-add')) {
  customElements.define('slider-also-add', SliderAlsoAdd);
}